<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">Solicitações de criação de contas para clientes</h1>
        </v-flex>
        <v-layout row wrap class="transactions-filter" pt-4 px-3>
          <v-flex xs12 md4 lg4 px-1>
            <v-select
              box
              label="Status da solicitação"
              v-model="filterRequestStatus"
              :items="filterRequestStatusItems"
              @change="setStatusFilter()"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4 lg4 px-1>
            <CompanySelect ref="filterCompanyId" :model="filterCompanyId" label="Parceiro" @onCompanyList="this.companyListSelected" @onIdSelected="this.companyIdSelected" />
          </v-flex>
          <v-flex xs12 md4 lg4 px-1>
            <CompanySelect ref="filterSubjectId" :model="filterSubjectId" :label="i18n('Nº do Doc. Cliente')" search_mode="document_number_prefix" @onCompanyList="this.subjectListSelected" @onIdSelected="this.subjectIdSelected" />
          </v-flex>
          <v-flex xs12 md4 lg4 px-1>
            <DefaultFilterDate ref="filterStartDate" @reload="this.reloadStartDate" kind="date" label="Data Inicial" />
          </v-flex>
          <v-flex xs12 md4 lg4 px-1>
            <DefaultFilterDate ref="filterEndDate" @reload="this.reloadEndDate" kind="date" label="Data Final" />
          </v-flex>
          <v-flex xs12 md4 lg4 class="align-contents-right">
            <v-btn class="filter-btn" color="#27DABC" depressed dark @click="filter()">
              Update
              <ion-icon name="funnel-outline"></ion-icon>
            </v-btn>
            <v-btn class="reload-filter-btn" flat icon color="white" @click="resetFilter()">
              <ion-icon name="reload-outline" size="large"></ion-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs12 class="body-container">
          <div class="mt-3" v-if="subjectFinancialAccountAuthorizationsLoaded == 'not_loaded'">Carregando Solicitações...</div>
          <div class="mt-3" v-if="subjectFinancialAccountAuthorizationsLoaded == 'error'">Algo errado. Não foi possível carregar as solicitações.</div>
          <div class="mt-3" v-if="subjectFinancialAccountAuthorizationsLoaded == 'not_authorized'">Não foi possível carregar as solicitações. Você não foi autorizado.</div>
          <div class="mt-3" v-if="subjectFinancialAccountAuthorizationsLoaded == 'empty'">Não existem solicitações neste momento.</div>

          <subject-financial-account-authorization-item
            :admin="true"
            :record="subjectFinancialAccountAuthorization"
            v-for="subjectFinancialAccountAuthorization in subjectFinancialAccountAuthorizations" :key="subjectFinancialAccountAuthorization.id"
            @loadRecords="loadSubjectFinancialAccountAuthorizations" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="showMoreBtn" @click="loadMoreRecords" block dark class="ma-0 btn-style">
            EXIBIR MAIS
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import SubjectFinancialAccountAuthorizationItem from "./SubjectFinancialAccountAuthorizationItem"
import CompanySelect from "./components/filters/CompanySelect"
import utils from "./shared/Utils"
import DefaultFilterDate from "./components/filters/DefaultFilterDate"

export default {
  name: 'AdminSubjectsFinancialAccountAuthorizationList',
  components: { layout: LeftBarLayout, 'subject-financial-account-authorization-item': SubjectFinancialAccountAuthorizationItem, CompanySelect, DefaultFilterDate },
  data() {
    return {
      subjectFinancialAccountAuthorizations: [],
      perPage: 100,
      subjectFinancialAccountAuthorizationsLoaded: 'not_loaded',
      filterRequestStatus: 'pending',
      filterCompanyId: null,
      filterSubjectId: null,
      filterCompanyList: [],
      filterSubjectList: [],
      filterStartDate: null,
      filterEndDate: null,
      last_id: null,
      consolidateFilter: {
        filterRequestStatus: 'pending',
        filterCompanyId: null,
        filterSubjectId: null,
        filterCompanyList: [],
        filterSubjectList: [],
        filterStartDate: null,
        filterEndDate: null,
      },
      filterRequestStatusItems: [
        {value: "approved", text: "Aprovados"},
        {value: "reproved", text: "Reprovados"},
        {value: "pending", text: "Pendentes"},
      ],
      error: false
    }
  },
  computed: {
    showMoreBtn() {
      if ((this.subjectFinancialAccountAuthorizations.length > 0) && (this.subjectFinancialAccountAuthorizations.length % 100 == 0)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.loadSubjectFinancialAccountAuthorizations(null)
  },
  methods: {
    resetToConsolidateFilter() {
      this.filterRequestStatus = this.consolidateFilter.filterRequestStatus
      this.$refs.filterRequestStatus.search = this.consolidateFilter.filterRequestStatus
      this.$refs.filterRequestStatus.entries = this.filterRequestStatusItems

      this.filterCompanyId = this.consolidateFilter.filterCompanyId
      this.filterCompanyList = [...this.consolidateFilter.filterCompanyList]
      this.$refs.filterCompanyId.entries = [...this.consolidateFilter.filterCompanyList]
      this.$refs.filterCompanyId.search = ''
      this.$refs.filterCompanyId.selectedCompanyId = this.consolidateFilter.filterCompanyId

      this.filterSubjectId = this.consolidateFilter.filterSubjectId;
      this.filterSubjectList = [...this.consolidateFilter.filterSubjectList]
      this.$refs.filterSubjectId.entries = [...this.consolidateFilter.filterSubjectList]
      this.$refs.filterSubjectId.search = ''
      this.$refs.filterSubjectId.selectedCompanyId = this.consolidateFilter.filterSubjectId

      this.filterStartDate = this.consolidateFilter.filterStartDate;
      this.$refs.filterStartDate.filterDate = this.consolidateFilter.filterStartDate;

      this.filterEndDate = this.consolidateFilter.filterEndDate;
      this.$refs.filterEndDate.filterDate = this.consolidateFilter.filterEndDate;
    },
    filter() {
      this.consolidateFilter = {
        filterRequestStatus: this.filterRequestStatus,
        filterCompanyId: this.filterCompanyId,
        filterCompanyList: [...this.filterCompanyList],
        filterSubjectId: this.filterSubjectId,
        filterSubjectList: [...this.filterSubjectList],
        filterStartDate: this.filterStartDate,
        filterEndDate: this.filterEndDate
      };

      this.loadSubjectFinancialAccountAuthorizations(null)
    },
    async resetFilter() {
      this.filterRequestStatus = 'pending'

      this.filterCompanyId = null
      this.$refs.filterCompanyId.search = null
      this.$refs.filterCompanyId.selectedCompanyId = null
      this.$refs.filterCompanyId.entries = []

      this.filterSubjectId = null
      this.$refs.filterSubjectId.search = null
      this.$refs.filterSubjectId.selectedCompanyId = null
      this.$refs.filterSubjectId.entries = []

      this.filterStartDate = null
      this.$refs.filterStartDate.filterDate = null

      this.filterEndDate = null
      this.$refs.filterEndDate.filterDate = null

      this.consolidateFilter = {
        filterRequestStatus: "pending",
        filterCompanyId: null,
        filterSubjectId: null,
        filterStartDate: null,
        filterEndDate: null,
        filterCompanyList: [],
        filterSubjectList: [],
      }

      this.loadSubjectFinancialAccountAuthorizations()
    },
    loadSubjectFinancialAccountAuthorizations(last_id) {
      this.resetToConsolidateFilter()

      let successCallback = (response) => {
        console.log('successCallback', response)

        if (response.body.data) {
          if (last_id != null && last_id != undefined) {
            this.subjectFinancialAccountAuthorizations = this.subjectFinancialAccountAuthorizations.concat(...response.body.data)
          } else {
            this.subjectFinancialAccountAuthorizations = response.body.data
          }

          if (this.subjectFinancialAccountAuthorizations.length === 0) {
            this.subjectFinancialAccountAuthorizationsLoaded = 'empty'
          } else {
            this.subjectFinancialAccountAuthorizationsLoaded = 'ok'
          }
        } else {
          this.subjectFinancialAccountAuthorizationsLoaded = 'error'
          debugger
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.subjectFinancialAccountAuthorizationsLoaded = 'not_authorized'
        } else {
          this.subjectFinancialAccountAuthorizationsLoaded = 'error'
        }
        console.log('errorCallback', response)
        debugger
      }

      let token = this.$cookies.get('api_token')
      let params = { per_page: this.perPage }

      if (this.consolidateFilter.filterStartDate) { params.from = utils.filterDateFrom(this.consolidateFilter.filterStartDate, false).toISOString() }
      if (this.consolidateFilter.filterEndDate) { params.to = utils.filterDateTo(this.consolidateFilter.filterEndDate, false).toISOString() }

      const addFilterToParams = function(value, field, params) {
        value = typeof value === 'string' ? value.trim() : value

        if (value === null || value === '' || typeof(value) === 'undefined') { return params }
        params[field] = value
        return params
      }

      const filters = [
        { value: last_id, field: 'last_id' },
        { value: this.consolidateFilter.filterRequestStatus, field: 'status' },
        { value: this.consolidateFilter.filterCompanyId, field: 'partner_id' },
        { value: this.consolidateFilter.filterSubjectId, field: 'subject_id' }
      ]

      filters.forEach(filter => {
        params = addFilterToParams(filter.value, filter.field, params)
      })

      const url = this.$root.urls.admin_subjects_financial_account_authorization

      this.$http.get(url, {params, headers: {Authorization: `Bearer ${token}`}}).then(successCallback, errorCallback)
    },
    resetToConsolidateFilter() {
      this.filterRequestStatus = this.consolidateFilter.filterRequestStatus
    },
    setStatusFilter() {
      this.consolidateFilter.filterRequestStatus = this.filterRequestStatus
    },
    companyListSelected(companyList) {
      this.filterCompanyList = companyList
    },
    subjectListSelected(subjectList) {
      this.filterSubjectList = subjectList
    },
    companyIdSelected(id) {
      this.filterCompanyId = id
    },
    subjectIdSelected(id) {
      this.filterSubjectId = id
    },
    loadMoreRecords(e) {
      if (this.subjectFinancialAccountAuthorizationsLoaded == "ok") {
        let lastId = this.subjectFinancialAccountAuthorizations.length - 1
        lastId = this.subjectFinancialAccountAuthorizations[lastId]['id']

        this.loadSubjectFinancialAccountAuthorizations(lastId)
      }
    },
    reloadStartDate(startDate) {
      this.filterStartDate = startDate
    },
    reloadEndDate(endDate) {
      this.filterEndDate = endDate
    },
    i18n(str) {
      return this.$root.l(str)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>
<style>
  .body-container {
    background-color: white;
    border-radius: 6px;
    margin-top: 20px;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/AdminSubjectsFinancialAccountAuthorizationList.vue